import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import TemplateHtml from './CourseAlertMessage.html';
var Size = {
        Small: 'relative bottom',
        Long: ''
    },
    AlertType = {
        Success: 'alert-success',
        Error: 'alert-error',
        Info: 'alert-info',
        Warning: 'alert-warning'
    };

var view = Backbone.View.extend({
    template: _.template(TemplateHtml),

    className: 'alert',

    events: {
        'click #alert': 'onDismissLinkClicked',
        'click a[data-action]': 'onLinkClicked'
    },

    initialize: function(args) {
        if (!args.message) {
            throw 'a message is required for the alert.';
        }

        this.message = args.message;
        this.size = args.size || Size.Long;
        this.alertType = args.alertType || AlertType.Success;
        this.showAlert = args.showAlert || false;
        this.callback = args.callback;
        this.localizeArgs = args.localizeArgs;

        return this;
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer,
                message: this.message,
                args: this.localizeArgs
            })
        );

        this.updateSizeInUI();
        this.updateAlertTypeInUI();

        if (this.showAlert) {
            this.displayAlert();
        } else {
            this.hideAlert();
        }

        return this;
    },

    setMessage: function(message) {
        if (message) {
            this.message = message;
            return true;
        }

        return this.message ? true : false;
    },

    setSize: function(size) {
        if (size) {
            if (size === 'small') {
                this.size = Size.Small;
                return true;
            }

            if (size === 'long') {
                this.size = Size.Long;
                return true;
            }

            if (size === Size.Long || size === Size.Small) {
                this.size = size;
                return true;
            }
        }

        return this.size ? true : false;
    },

    setAlertType: function(alertType) {
        if (alertType) {
            if (alertType === 'success') {
                this.alertType = AlertType.Success;
                return true;
            }

            if (alertType === 'error') {
                this.alertType = AlertType.Error;
                return true;
            }

            if (alertType === 'info') {
                this.alertType = AlertType.Info;
                return true;
            }

            if (alertType === 'warning') {
                this.alertType = AlertType.Warning;
                return true;
            }

            if (
                alertType === AlertType.Success ||
                alertType === AlertType.Error ||
                alertType === AlertType.Info ||
                AlertType.Warning
            ) {
                this.alertType = alertType;
                return true;
            }
        }
        return this.alertType ? true : false;
    },

    updateSizeInUI: function() {
        if (this.size === Size.Small) {
            this.$el.addClass(Size.Small);
        } else if (this.size === Size.Long) {
            this.$el.removeClass(Size.Small);
        }
    },

    updateAlertTypeInUI: function() {
        if (this.alertType === AlertType.Success) {
            this.$el.addClass(AlertType.Success);
            this.$el.removeClass(AlertType.Error);
            this.$el.removeClass(AlertType.Info);
        } else if (this.alertType === AlertType.Error) {
            this.$el.addClass(AlertType.Error);
            this.$el.removeClass(AlertType.Success);
            this.$el.removeClass(AlertType.Info);
        } else if (this.alertType === AlertType.Info) {
            this.$el.addClass(AlertType.Info);
            this.$el.removeClass(AlertType.Error);
            this.$el.removeClass(AlertType.Success);
        } else if (this.alertType === AlertType.Warning) {
            this.$el.addClass(AlertType.Warning);
            this.$el.removeClass(AlertType.Error);
            this.$el.removeClass(AlertType.Success);
            this.$el.removeClass(AlertType.Info);
        }
    },

    setAndRenderAlert: function(message, size, alertType, callback, localizeArgs) {
        var hasMessage = this.setMessage(message),
            hasSize = this.setSize(size),
            hasAlertType = this.setAlertType(alertType);
        this.localizeArgs = localizeArgs;

        if (hasMessage && hasSize && hasAlertType) {
            this.showAlert = true;
            this.callback = callback;
            this.render();
        }
    },

    displayAlert: function() {
        this.$el.show();
    },

    hideAlert: function() {
        this.$el.hide();
    },

    onDismissLinkClicked: function(e) {
        e.preventDefault();
        this.hideAlert();
    },

    onLinkClicked: function(e) {
        e.preventDefault();
        if (this.callback) {
            this.callback();
        }
        this.hideAlert();
    }
});

view.Size = Size;
view.AlertType = AlertType;

export default view;
